// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-width: 800px;
  margin: 0 auto;
  background: #f9fafb;
}

.chat-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.chat-back-btn {
  padding: 0.4rem 0.8rem;
  background: none;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #374151;
}

.chat-back-btn:hover {
  background: #f3f4f6;
}

.chat-job-info {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  flex: 1 1;
  min-width: 0;
}

.chat-job-info h2 {
  margin: 0;
  font-size: 1.1rem;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-job-price {
  font-weight: 600;
  color: #2563eb;
  font-size: 0.95rem;
  white-space: nowrap;
}

.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.chat-empty {
  text-align: center;
  color: #9ca3af;
  margin-top: 2rem;
}

.chat-bubble {
  max-width: 75%;
  padding: 0.7rem 1rem;
  border-radius: 12px;
  word-wrap: break-word;
}

.chat-bubble-own {
  align-self: flex-end;
  background: #2563eb;
  color: white;
}

.chat-bubble-other {
  align-self: flex-start;
  background: white;
  color: #111827;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.chat-sender {
  display: block;
  font-size: 0.7rem;
  margin-bottom: 0.2rem;
  opacity: 0.7;
}

.chat-content {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.4;
}

.chat-time {
  display: block;
  font-size: 0.65rem;
  margin-top: 0.3rem;
  opacity: 0.6;
  text-align: right;
}

.chat-input-area {
  display: flex;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  background: white;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.chat-input {
  flex: 1 1;
  padding: 0.7rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.95rem;
  outline: none;
}

.chat-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
}

.chat-send-btn {
  padding: 0.7rem 1.2rem;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
}

.chat-send-btn:hover:not(:disabled) {
  background: #1d4ed8;
}

.chat-send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/ChatPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".chat-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  max-width: 800px;\n  margin: 0 auto;\n  background: #f9fafb;\n}\n\n.chat-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  background: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  flex-shrink: 0;\n}\n\n.chat-back-btn {\n  padding: 0.4rem 0.8rem;\n  background: none;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: #374151;\n}\n\n.chat-back-btn:hover {\n  background: #f3f4f6;\n}\n\n.chat-job-info {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.chat-job-info h2 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chat-job-price {\n  font-weight: 600;\n  color: #2563eb;\n  font-size: 0.95rem;\n  white-space: nowrap;\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n\n.chat-empty {\n  text-align: center;\n  color: #9ca3af;\n  margin-top: 2rem;\n}\n\n.chat-bubble {\n  max-width: 75%;\n  padding: 0.7rem 1rem;\n  border-radius: 12px;\n  word-wrap: break-word;\n}\n\n.chat-bubble-own {\n  align-self: flex-end;\n  background: #2563eb;\n  color: white;\n}\n\n.chat-bubble-other {\n  align-self: flex-start;\n  background: white;\n  color: #111827;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\n}\n\n.chat-sender {\n  display: block;\n  font-size: 0.7rem;\n  margin-bottom: 0.2rem;\n  opacity: 0.7;\n}\n\n.chat-content {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.4;\n}\n\n.chat-time {\n  display: block;\n  font-size: 0.65rem;\n  margin-top: 0.3rem;\n  opacity: 0.6;\n  text-align: right;\n}\n\n.chat-input-area {\n  display: flex;\n  gap: 0.5rem;\n  padding: 1rem 1.5rem;\n  background: white;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);\n  flex-shrink: 0;\n}\n\n.chat-input {\n  flex: 1;\n  padding: 0.7rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  outline: none;\n}\n\n.chat-input:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);\n}\n\n.chat-send-btn {\n  padding: 0.7rem 1.2rem;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.chat-send-btn:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.chat-send-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
